import Wrapper from "../components/Wrapper"
import { email_address, phone_number, name} from "../Data";

function Contact() {
    return (
        <div>
            <Wrapper title={ "Contact" }>
                <div>
                    <h1>Contact { name }:</h1>
                    <p>Email: <a href={ `mailto:${email_address}` }>{ email_address }</a></p>
                    <p>Phone: <a href={`tel:${phone_number}`}>{ phone_number }</a></p>
                </div>
                <br/>
                <br/>
                <img alt="" src="/images/logo.jpg" width="100%" />
            </Wrapper>
        </div>
    );
}

export default Contact;